<div class="game-selector">
  <button class="back-btn" (click)="goBack()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <h2 class="selector-title">{{ currLang === 'ar' ? 'اختر اللعبة' : 'Choose a Game' }}</h2>

  <div class="games-grid">
    <div
      *ngFor="let game of games"
      class="game-card"
      [class.disabled]="isDisabled(game)"
      [style.--game-color]="game.color"
      (click)="selectGame(game)">

      <div class="game-icon" [innerHTML]="game.icon"></div>
      <div class="game-info">
        <div class="game-name">{{ getName(game) }}</div>
        <div class="game-desc">{{ getDesc(game) }}</div>
      </div>
      <div class="game-meta">
        <span class="meta-badge questions">{{ game.questionsCount | arabicNumber:currLang }}{{ currLang === 'ar' ? 'س' : 'Q' }}</span>
        <span class="meta-badge time" *ngIf="game.timePerQuestion">{{ game.timePerQuestion | arabicNumber:currLang }}{{ currLang === 'ar' ? 'ث' : 's' }}</span>
      </div>
      <div class="needs-students" *ngIf="isDisabled(game)">
        {{ currLang === 'ar' ? 'يحتاج طلاب' : 'Needs students' }}
      </div>
    </div>
  </div>
</div>
